export const SET_ACTIVITIES = 'ACTIVITIES/SET_ACTIVITIES';
export const HANDLE_LOADING = 'ACTIVITIES/HANDLE_LOADING';
